import AGSCancelAutoControl from "ags/controls/ags-cancel-auto-control";
import AgsCreditSizeSliderControl from "ags/controls/ags-credit-size-slider-control";
import { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import ControlList from "slotworks/smart-ui/control-list";
import { JackpotTiers } from "../names";
import AGSAccountsButtonControl from "./ags-accounts-button-control";
import AgsCreditSizeStepperControl from "./ags-credit-size-stepper-control";
import AGSDepositButtonControl from "./ags-deposit-button-control";
import AGSHomeButtonControl from "./ags-home-button-control";
import AgsMaxBetButtonControl from "./ags-max-bet-button-control";
import JackpotValuesControl from "./jackpot-values-control";
import AgsPaytableControl from "ags/controls/ags-paytable-control";

export default class AgsControlList {

    public static JACKPOT_VALUES = new ControlList<JackpotValuesControl>(JackpotValuesControl, "jackpot_text_",
        [JackpotTiers.MINI + "_" + Orientation.PORTRAIT,
            JackpotTiers.MINI + "_" + Orientation.LANDSCAPE,
            JackpotTiers.MINOR + "_" + Orientation.PORTRAIT,
            JackpotTiers.MINOR + "_" + Orientation.LANDSCAPE,
            JackpotTiers.MAJOR + "_" + Orientation.PORTRAIT,
            JackpotTiers.MAJOR + "_" + Orientation.LANDSCAPE,
            JackpotTiers.GRAND + "_" + Orientation.PORTRAIT,
            JackpotTiers.GRAND + "_" + Orientation.LANDSCAPE
        ]);

    public static AGS_HOME_BUTTON = new ControlList<AGSHomeButtonControl>(AGSHomeButtonControl, "ags_home");
    public static AGS_DEPOSIT_BUTTON = new ControlList<AGSDepositButtonControl>(AGSDepositButtonControl, "ags_deposit");
    public static AGS_ACCOUNTS_BUTTON = new ControlList<AGSAccountsButtonControl>(AGSAccountsButtonControl, "ags_accounts");
    public static AGS_MAX_BET_BUTTON = new ControlList<AgsMaxBetButtonControl>(AgsMaxBetButtonControl, "ags_max_bet");
    public static AGS_CREDIT_SIZE_STEPPER = new ControlList<AgsCreditSizeStepperControl>(AgsCreditSizeStepperControl, "ags_credit_size_stepper", ["_up", "_down", "_value"]);
    public static AGS_CREDIT_SIZE_SLIDER = new ControlList<AgsCreditSizeSliderControl>(AgsCreditSizeSliderControl, "credit_size_slider", ["_up", "_down", "_value"]);
    public static AGS_CANCEL_AUTO_CONTROL = new ControlList<AGSCancelAutoControl>(AGSCancelAutoControl, "auto_stop");
    public static AGS_PAYTABLE = new ControlList<AgsPaytableControl>(AgsPaytableControl, "paytable", ["_previous", "_next"]);

    public static init() {
        ControlList.removeControl(ControlList.PAYTABLE);

        ControlList.addControlList(AgsControlList.JACKPOT_VALUES);
        ControlList.addControlList(AgsControlList.AGS_HOME_BUTTON);
        ControlList.addControlList(AgsControlList.AGS_DEPOSIT_BUTTON);
        ControlList.addControlList(AgsControlList.AGS_ACCOUNTS_BUTTON);
        ControlList.addControlList(AgsControlList.AGS_MAX_BET_BUTTON);
        ControlList.addControlList(AgsControlList.AGS_CREDIT_SIZE_STEPPER);
        ControlList.addControlList(AgsControlList.AGS_CREDIT_SIZE_SLIDER);
        ControlList.addControlList(AgsControlList.AGS_CANCEL_AUTO_CONTROL);
        ControlList.addControlList(AgsControlList.AGS_PAYTABLE);
    }
}
